<script>
export default {
  name: 'Guard1000EventMixin',
  destroyed() {
    this.resetStore();
  },
  methods: {
    filterEvents(value) {
      switch (true) {
        case !value:
          this.payload = {
            q: {},
            data_type: [this.eventTypesSelectOptions[0]]
          };

          break;
        case !!value.event:
          this.payload = { ...this.payload, data_type: [value.event] };

          break;
        case !!value.label:
          this.payload = {
            q: {},
            data_type: [this.eventTypesSelectOptions[0]]
          };

          break;
        case !!value.selectedDate:
          this.generateTimestamps(value);

          break;
        default:
          break;
      }
      this.getPage({ page: this.paginationParams, ...this.payload });
    },
    resetEventSelection() {
      this.selectedEventType = this.eventTypesSelectOptions[0];
    },
    eventChanged(newSelectedEventValue) {
      this.selectedEventType = newSelectedEventValue;

      this.filterEvents(newSelectedEventValue);
    }
  }
};
</script>
